<div #point_1 class="container">

    <h1 class="my-4 pb-3 fw-bold border-bottom border-2">
        {{ bDetail ? lst_Educations[0]?.strTitle : 'فیلم های آموزشی مرتبط با ردیاب، خودرو و موتورسیکلت ' }}
    </h1>

    <div class="row gx-0 gy-2">

        <div *ngIf="!bDetail" class="search-container p-3">
            <input class="form-control w-100" 
                (input)="search_Educations($event.target.value)"
                placeholder="عنوان آموزش را جستجو کنید...">
        </div>

        <ng-container *ngFor="let item of lst_Educations">

            <div [ngClass]="bDetail ? 'col-12' : 'col-md-4 col-12' " class="p-3 pointer" (click)="openEducation(item)">

                <div class="card w-100 h-100">
                    
                    <div class="video-container">

                        <iframe class="responsive-iframe"

                            [src]="item.strContentPath" 

                            frameborder="0" 

                            allowfullscreen 

                            webkitallowfullscreen 

                            mozallowfullscreen>

                        </iframe>

                    </div>     

                    <div class="card-body">
                        
                        <h4 class="card-title mb-1" style="height: 84px;font-size: 15px;line-height: 23px;">  
                            
                            {{ bDetail ? item.strTitle : subString_Title(item.strTitle,63) | faNum }}     
                                               
                        </h4>
                        
                        <p class="card-text text-muted" style="height: 70px;font-size: 12px;"> 
                            
                            {{ bDetail ? item.strDetail : subString_Title(item.strDetail,130) | faNum}}
                            
                        </p>
                        
                    </div>

                </div>
            </div>
        </ng-container>

    </div>

</div>
